import { authHeaders, requestJson } from './http';

const API_BASE_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:8000';
export const ANALYTICS_POLICY_VERSION = 'product-analytics-v1' as const;
export type AnalyticsAudience = 'adult' | 'donor';
export interface AnalyticsPreference {
  allowed: boolean;
  policy_version: typeof ANALYTICS_POLICY_VERSION;
}

async function requestPreference(
  audience: AnalyticsAudience,
  signal?: AbortSignal,
  allowed?: boolean,
): Promise<AnalyticsPreference> {
  const updating = allowed !== undefined;
  const prefix = audience === 'adult' ? 'measurements' : 'donor-session';
  const response = await requestJson<AnalyticsPreference>(`${API_BASE_URL}/${prefix}/analytics-preference`, {
    method: updating ? 'PUT' : 'GET',
    credentials: audience === 'donor' ? 'include' : 'omit',
    headers: audience === 'adult' ? authHeaders(updating) : (updating ? { 'Content-Type': 'application/json' } : {}),
    cache: 'no-store',
    signal,
    ...(updating ? { body: JSON.stringify({ allowed, policy_version: ANALYTICS_POLICY_VERSION }) } : {}),
  });
  if (typeof response?.allowed !== 'boolean' || response.policy_version !== ANALYTICS_POLICY_VERSION) {
    throw new Error('Analytics preference could not be confirmed.');
  }
  return response;
}

export const fetchAnalyticsPreference = (audience: AnalyticsAudience, signal?: AbortSignal) =>
  requestPreference(audience, signal);

export const saveAnalyticsPreference = (audience: AnalyticsAudience, allowed: boolean, signal?: AbortSignal) =>
  requestPreference(audience, signal, allowed);
